import React from 'react';

import { AmbaDropdownItem, AmbaDropdownPropsType } from '@/models/globalModels';

export const AmbaDropdown = ({
  id,
  options = [],
  ariaDescribedBy,
  onClick,
  disabled = false,
  placeHolder,
  value = '',
  extraClass,
  labelText,
  extraLabelClass,
  bgColor,
  width,
  isRequired = false,
  validationMessage,
  hasValidation = false,
  validator,
}: AmbaDropdownPropsType) => {
  const [isSelected, setIsSelected] = React.useState(false);
  const [selectedItem, setSelectedItem] = React.useState<AmbaDropdownItem>();
  const customStyle: React.CSSProperties = {
    backgroundColor: bgColor,
    width: width,
  };

  // TODO: Add onBlur and onChange validation to display invalid field visual icon for dropdown
  const handleClick = (selectedItem: AmbaDropdownItem) => {
    setIsSelected(true);
    setSelectedItem(selectedItem);
    if (onClick) onClick(selectedItem);
  };

  return (
    <div className="AmbaDropdown">
      {labelText && (
        <label className={`f-15 f-roboto-semiBold ${extraLabelClass}`} htmlFor={id}>
          {isRequired ? labelText.concat(' *') : labelText}
        </label>
      )}
      <div className={`dropdown DropdownSelector ${extraClass}`}>
        <button
          aria-expanded="false"
          className="btn btn-secondary dropdown-toggle f-raleway-bold p-1 selectorInput d-flex align-items-center"
          data-bs-toggle="dropdown"
          disabled={disabled}
          id={id}
          style={customStyle}
          type="button"
        >
          <p className="ps-2 f-14 d-flex">{isSelected ? selectedItem?.itemText : placeHolder}</p>
          <i className={`icon-arrow-down-dark ms-auto me-2 mt-1 f-10 expand-arrow`} />
        </button>
        <ul aria-labelledby={id} className="dropdown-menu scrollable-menu b-0">
          {options.map((i) => (
            <li key={i.itemTextKeyName} className={`f-14 ps-3 py-2 ${i.extraItemClass}`} onClick={() => handleClick(i)}>
              {i.itemText}
            </li>
          ))}
        </ul>
      </div>
      <div className={`invalid-feedback ${validationMessage ? 'd-block' : ''}`}>{validationMessage}</div>
    </div>
  );
};

export default AmbaDropdown;
